<template>
  <div class="animated revealUp">
      
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t('edit') }} {{ $t('cardtype') }}</div>
      <div>
        <router-link class="btn-blue" to="card-type">{{ $t('cardtype') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                v-model="cardDetails.card_type"
                v-validate="{required: 'required'}"
                placeholder="."
                type="text"
                name="card_type"
                id="card_type"
              />
              <label>{{ $t('cardtype') }}</label>
            </div>
            <Tooltip :title="$t('enterCardType')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('card_type')">{{ errors.first('card_type') }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label
              :class="selected.bank && selected.bank.length > 0 ? 'shift-up' : 'd-none' "
            >{{ $t('bank') }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="selected.bank" variant="dropdown-curve" class="w-100"> -->
              <!-- <b-dropdown-item v-on:click="selected.bank = 'Select'">Select</b-dropdown-item> -->
              <!-- <b-dropdown-item
                  v-for="(bank, bankIndex) in banks"
                  :key="bankIndex"
                  v-on:click="onSelectHandler('bank',bank)"
                  name="bankmsg"
                  id="bankmsg"
                >{{ bank.bank_name }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="banks"
                :searchable="true"
                :placeholder="selected.bank && selected.bank.length > 0 ? selected.bank: 'Select Bank'"
                label="bank_name"
                track-by="bank_id"
                @select="onSelectHandler('bank',$event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
              <Tooltip :title="$t('enterbankname')" />
            </div>
            <p class="error_message">
              <span
                v-if="submitted && selected.bank && selected.bank.length == 0"
              >Please select bank.</span>
            </p>
          </div>
        </div>

        <div class="col-lg-12 align-self-center mb-4">
          <div class="input-material">
            <label>{{ $t('binNumbers') }} :- {{ BinNumbers && BinNumbers.length > 0 ? BinNumbers.toString() : '-' }}</label>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t('active') }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  unchecked-value="N"
                  value="Y"
                  v-model="cardDetails.card_is_active"
                  name="check-button"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button @click.prevent.stop="onFinalSubmit(true)" class="btn-blue">{{ $t('update') }}</button>
          <!-- <button class="btn-blue">{{ $t('saveaddmore') }}</button>
          <button class="btn-black">{{ $t('reset') }}</button>-->
          <b-button
            @click.prevent.stop="onResetForm()"
            class="btn-outline-grey"
            variant="default"
            to="card-type"
          >{{ $t('cancel') }}</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { METHODS } from "http";
const selected = {
  bank: "",
};

export default {
  data() {
    return {
      banks: [],
      banksMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_banks",
        urlKey: "banks",
      },
      selected: selected,
      submitted: false,
      items: [],
      cardDetails: {
        card_type: null,
        bank_id: "",
        card_is_active: "",
        card_id: "",
      },
      BinNumbers: [],
    };
  },
  beforeMount() {
    const { card_id } = this.$route.query;
    // console.log("ot_id :", ot_id);
    if (card_id) {
      this.getCardDetails(card_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getCardDetails: function (card_id) {
      MarketingService.getSingleCardDetails({ card_id }).then((response) => {
        const { data } = response;
        // console.log("data :", data);
        if (data.Records) {
          this.cardDetails = {
            ...this.cardDetails,
            ...data.Records[0],
          };
          this.BinNumbers = data.BinNumbers.join(", ");
          this.getBanksList(data.Records[0].bank_id);
        }
      });
    },
    onResetForm: function () {
      (this.cardDetails.card_type = null), (this.selected.bank = null);
    },
    // },
    getBanksList: function (bank_id) {
      this.banks = [];
      let payload = {
        tableName: "ms_banks",
        bank_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.banks = data.Records;
            if (bank_id) {
              this.banks.map((x) => {
                if (bank_id === x.bank_id) {
                  this.selected.bank = x.bank_name;
                  // console.log(
                  //   "this.selected.marketing_type :",
                  //   this.selected.marketing_type
                  // );
                  this.onSelectHandler("bank", x);
                }
              });
            }
          } else {
            //  this.$toasted.show("5"+data.message);
          }
        })
        .catch(this._CatchError);
    },

    onSelectHandler: function (type, value) {
      if (type == "bank") {
        // console.log("value :", value);
        this.selected.bank = value.bank_name;
        this.cardDetails.bank_id = value.bank_id;
      }
    },
    onFinalSubmit: function (redirect) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (this.cardDetails.bank_id.length == 0) {
          return;
        }
        if (valid) {
          MarketingService.editCardType({ ...this.cardDetails })
            .then((response) => {
              const { data } = response;
              if (data.status) {
                this.$toasted.show(data.message);

                if (redirect) {
                  this.onResetForm(),
                    this.$router.push({
                      path: "/marketing/card-type",
                    });
                }
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CardTypeComponents/editCardType.vue